import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";

/**
 * Public signup payload — Batch 27f locked contract.
 *
 *   - `name` is GONE; replaced by `first_name` + `last_name`, both required
 *     (min 1 char each — the backend `EmailStr`/length validators reject
 *     empty strings, so the form blocks submission first).
 *   - `email` is the username/login identifier (no separate username concept).
 *   - All three legal versions stay required and locked at the call site.
 */
type SignupInput = {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  company_name: string;
  company_website?: string;
  terms_version: string;
  privacy_version: string;
  dpa_version: string;
  accepted_legal: true;
  // Click-through evidence — browser IANA time zone + UTC offset at acceptance.
  client_timezone?: string;
  client_utc_offset_minutes?: number;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
};

type SignupResponse = {
  message: string;
};

export function useSignup() {
  return useMutation<SignupResponse, ApiError, SignupInput>({
    mutationFn: async (input) => {
      const resp = await apiClient.post<SignupResponse>("/auth/signup", input);
      return resp.data;
    },
  });
}
